import React from "react";
import Typography from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import info from "../../../assets/debate/flyer.jpg";

const Details = () => {
  return (
    <>
      <Grid container margin={{ xs: "8% 0%", sm: "2% 0%" }}>
        <Grid xs={12} sm={6} paddingRight={"3%"}>
          <Typography
            variant={"body1"}
            color={"#000"}
            paddingBottom={"4%"}
            lineHeight={1.5}
          >
            On October 12, 2024, the Oluseun Onigbinde Resource Centre, in
            collaboration with Lions International (District 404B2), organized a
            highly engaging Inter-Secondary School Debate at the Atimagies Hotel
            Hall in Ogbomoso. The debate topic, "Should the Nigerian Government
            have Removed Subsidy on Petrol?" brought together six secondary
            schools: Federal Government College, Ogbomoso; Anglican Model
            College; Ogbomoso High School; Anglican High School; Relics College;
            and Minaret International College. This event provided a platform
            for the students to showcase their critical thinking and debating
            skills on a pressing national issue, which sparked insightful
            discussions on both sides of the argument.
          </Typography>
          <Typography
            variant={"body1"}
            color={"#000"}
            paddingBottom={"4%"}
            lineHeight={1.5}
          >
            Each school presented well-researched arguments, reflecting a deep
            understanding of the complexities surrounding the removal of
            subsidies on petrol in Nigeria. The audience, which included
            students, teachers, and other members of the community, was
            captivated by the depth of knowledge and passion demonstrated by the
            participants. The debate was judged by a panel of experts who
            assessed the presentations based on content, delivery, and overall
            performance.
          </Typography>
          <Typography
            variant={"body1"}
            color={"#000"}
            paddingBottom={"4%"}
            lineHeight={1.5}
          >
            At the conclusion of the event, the results were as follows:
            Anglican High School secured the 6th position with 72 points,
            followed by Ogbomoso High School with 72.3 points in 5th place.
            Relics College came in 4th with 74.6 points, while
            <Typography component={"span"} fontWeight={700} color={"#071783"}>
              {" "}
              Anglican Model College
            </Typography>{" "}
            earned the{" "}
            <Typography component={"span"} fontWeight={700} color={"#071783"}>
              3rd position{" "}
            </Typography>
            with 77.5 points.
            <Typography component={"span"} fontWeight={700} color={"#071783"}>
              {" "}
              Federal Government College, Ogbomoso
            </Typography>{" "}
            took{" "}
            <Typography component={"span"} fontWeight={700} color={"#071783"}>
              2nd place{" "}
            </Typography>
            with an impressive 81.35 points.
            <Typography component={"span"} fontWeight={700} color={"#071783"}>
              {" "}
              Minaret International College
            </Typography>{" "}
            emerged as the overall winner, claiming{" "}
            <Typography component={"span"} fontWeight={700} color={"#071783"}>
              {" "}
              1st position{" "}
            </Typography>
            with 82.35 points. The 1st, 2nd and 3rd positions won cash prizes of
            N100,000, N75,000 and N50,000 respectively. The event was a
            resounding success, and the students gained valuable experience in
            public speaking, critical thinking, and teamwork.
          </Typography>
        </Grid>
        <Grid xs={12} sm={6} display={{ xs: "none", sm: "block" }}>
          <Box
            component="img"
            height={{ xs: "95vh", sm: "650px" }}
            sx={{
              objectFit: "cover",
              width: "100%",
            }}
            src={info}
            alt={"image"}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Details;
